<template>
  <div id="app3">
    <canvas id="planet-chart2">
    </canvas>
    <br>
    <h2 v-if="dataSelected" id="synthese" style="margin=5vh">
      Avec une évolution du nombre de passagers transportés de <b v-if="dataSelected.pct_evol_eurostats>0">+{{dataSelected.pct_evol_eurostats}}%</b><b v-else>{{dataSelected.pct_evol_eurostats}}%</b> entre 2010 et 2019 pour atteindre un nombre de passagers transportés de <b>{{dataSelected.sum2019}}</b> en 2019.
      On peut dire que la dynamique de la ville aéroportuaire de {{selected}} en terme de trafic de passagers est 
      <b v-if="dataSelected.pct_evol_eurostats >= 100">exceptionnelle</b>
      <b v-else-if="dataSelected.pct_evol_eurostats > 50">très bonne</b>
      <b v-else-if="dataSelected.pct_evol_eurostats > 20">bonne</b>
      <b v-else-if="dataSelected.pct_evol_eurostats > 0">moyenne</b>
      <b v-else-if="dataSelected.pct_evol_eurostats > -10">faible</b>
      <b v-else-if="dataSelected.pct_evol_eurostats > -31">très faible</b>
      <b v-else>très mauvaise, le transport aérien de passagers est en perdition pour {{selected}}</b>
      </h2>
  </div>
</template>
<script>
import Chart from "chart.js";
import dataFly from "../data/data_all_evol.json";
import * as d3 from "d3";

export default {
  name: "App",
  dataFly: dataFly,
  dataToGraph: [],
  dataOthers: null,
  termesDGAC: {
    dessertes: "Nombre total de dessertes",
    dessertes_reg: "Nombre de dessertes régulières",
    dessertes_non_reg: "Nombre de dessertes non régulières",
    pax_total:
      "Nombre total de passagers locaux + en transit des vols commerciaux (sans double compte)",
    pax_reg: "Nombre total de passagers d'un vol régulier",
    pax_non_reg: "Nombre total de passagers d'un vol non régulier",
    fret_total: "Poids total estimé de marchandises d'un vol",
  },
  selectedYear: null,
  yearsDGAF: ["1999", "2004", "2009", "2014", "2019"],
  props: {
    selected: {
      type: String,
    },
  },
  dataInOut: null,
  bubbleChartData: null,
  data() {
    return {
        dataSelected: null,
};
  },
  created() {
    this.airport = this.$props.selected;
  },
async mounted() {
     await import("../data/data_all_evol.json").then((res)=>{ 
       return JSON.parse(JSON.stringify(res))
       })
      .then((e) => {

      let data = [];
      let dataToScale = [];
      for(let i in e){
        if(i!="default" && (e[i].ville == this.airport)){
            this.dataSelected = e[i];
            dataToScale.push(e[i].sum2019)
        }
        else if(i!="default" && e[i].ville != "PARIS"){
          let dataOthers = {};
          dataOthers.y = e[i].sum2019
          dataOthers.x = e[i].pct_evol_eurostats
          dataOthers.label = e[i].ville
          dataOthers.pass = e[i].sum2019
          dataToScale.push(e[i].sum2019)
          data.push(dataOthers);
        }
      }
        let maxOut = d3.max(Object.values(dataToScale));
        let meanOut = d3.mean(Object.values(dataToScale));
        let minOut = d3.min(Object.values(dataToScale));
        let valued3 = d3
          .scaleLinear(10)
          .domain([minOut, meanOut, maxOut])
          .range([5, 15, 30, 60]);

      for(let j=0; j<data.length;j++){
        data[j].r = valued3(data[j].pass);
      }
      this.dataOthers = data;

      this.bubbleChartData = {
      type: "bubble",
      data: {
        datasets: [
          {
          label: [this.airport],
          data : [{
            y: this.dataSelected.sum2019,
            x: this.dataSelected.pct_evol_eurostats,
            r: valued3(this.dataSelected.sum2019),
            label: this.dataSelected.ville,
            pass: this.dataSelected.sum2019
          }],
          backgroundColor: [
                "rgba(255, 0, 102,.5)",
              ],
              borderColor: [
                "rgba(255, 0, 102)",
              ],
              borderWidth: 1,
          },
        {
          label:"Autres villes aéroportuaires",
          data,
            backgroundColor: [
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
              "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
                "rgba(0, 102, 255,.5)",
              ],
              borderColor: [
              ],
              borderWidth: 1,
          },
        ],
      },
        options: {
          legend: {
            labels: {
                fontColor: 'black'
            }},
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                scaleLabel : {
                  display: true,
                  labelString: 'Nombre de passagers transportés (intra et hors France) en 2019',
                  fontColor: 'black'
                },
                ticks: {
                  beginAtZero: false,
                  padding: 25,
                  fontColor: 'black'
                },
              },
            ],
            xAxes: [
              {
                scaleLabel :{
                  display: true,
                  labelString: 'Evolution du nombre de passagers transportés (intra et hors France) de 2010 à 2019',
                  fontColor: 'black'
                },
                ticks: {
                  fontColor: 'black'
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                  let test = null;
                  data.datasets[tooltipItem.datasetIndex].data.forEach((e)=>{
                    if(e.x == parseFloat(tooltipItem.xLabel) && e.y == parseFloat(tooltipItem.yLabel)){
                      test = e;
                    }
                  });
                    var label = test.label || ' : <br>Nombre de passagers en 2019 : ' + test.pass;

                    if (label) {
                        label += ': ';
                    }
                    label += "Evolution du nb de passagers totaux (intra et hors France) depuis 2010 : "+tooltipItem.xLabel+ "%";
                    label += ";  Nombre de passagers (intra et hors France) en 2019 : " + test.pass;


                    return label;
                },
            },
            enabled: false,
            custom: function(tooltipModel) {
                var tooltipEl = document.getElementById('chartjs-tooltip');

                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    tooltipEl.innerHTML = '<table></table>';
                    document.body.appendChild(tooltipEl);
                }

                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    return;
                }

                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem) {
                    return bodyItem.lines;
                }

                if (tooltipModel.body) {
                    var titleLines = tooltipModel.title || [];
                    var bodyLines = tooltipModel.body.map(getBody);

                    var innerHtml = '<thead>';

                    titleLines.forEach(function(title) {
                        innerHtml += '<tr><th>' + title + '</th></tr>';
                    });
                    innerHtml += '</thead><tbody>';

                    bodyLines.forEach(function(body, i) {
                        var colors = tooltipModel.labelColors[i];
                        var style = 'background:' + colors.backgroundColor;
                        style += '; border-color:' + colors.borderColor;
                        style += '; border-width: 2px';
                        var span = '<span style="' + style + '"></span>';
                        innerHtml += '<tr><td>' + span + body + '</td></tr>';
                    });
                    innerHtml += '</tbody>';

                    var tableRoot = tooltipEl.querySelector('table');
                    tableRoot.innerHTML = innerHtml;
                }
                var position = this._chart.canvas.getBoundingClientRect();
                tooltipEl.style.opacity = 1;
                tooltipEl.style.backgroundColor = "white";
                tooltipEl.style.position = 'absolute';
                tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                tooltipEl.style.pointerEvents = 'none';
            }
        },
        },
      };
        this.createChart("planet-chart2", this.bubbleChartData);
      })

  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
  },
};
</script>
<style>
#planet-chart {
  right: 0%;
  width: 30vw;
  display: flex;
  z-index: 1;
  font-family: "Open Sans", sans-serif;
}
</style>
